<style>
.app-header.navbar {
  background-color: #f3f3f3;
}

.navbar-header {
  margin-right: 20px;
  /*font-size: 14px;*/
}

.menu ul {
  display: inline-block;
}

.menu ul li {
  display: inline-block;
  margin-left: 15px;
}

.menu ul li:first-child {
  margin-left: 0px;
}

.menu ul li a {
  color: #424242;
  text-decoration: none;
}

.navbar-nav {
  height: 30px;
  padding: 4px 5px 5px 3px;
  margin-right: 5px;
}

.menu ul:hover, .menu ul:hover li a {
  background-color: #2fceff;
  cursor: pointer;
  color: #fff!important;
  font-weight: 600;
  border-radius:5px;
}

.menu ul > li a.active {
  color: #fff;
  background-color: #2fceff;
  text-decoration: none;
  padding: 5px 6px;
  font-weight: 600;
  border-radius:5px;
}

.navbar-header .router-link-exact-active img{
  width: 70%;
  margin-left: 25px;
}
.dropdown-menu{
  top: 45px;
  right:0px;
  left: -102px;
}
</style>

<template>
  <header class="app-header navbar">
    <div class="navbar-header">
      <router-link :to="{name:''}">
        <img src="static/img/logo.png" />
      </router-link>
    </div>
    <div class="menu">
      <ul
        @click="navigateTo(`${RowEle.url}`)"
        v-bind:key="RowEle.name"
        v-for="RowEle in navItem"
        class="nav navbar-nav"
      >
        <li>
          <router-link :to="RowEle.url">
            <i class="fa fa-clipboard-list" style="color: #424242;"></i>
            {{RowEle.name}}
          </router-link>
        </li>
      </ul>
      <ul class="nav navbar-nav">
        <li>
          <a :href="analytics_dashboard_url" target="_blank" rel="noopener noreferrer">
            <i class="fa fa-chart-line" style="color: #424242;"></i>
            Analytics
          </a>
        </li>
      </ul>
      <ul v-if="showUccpDashboard" class="nav navbar-nav">
        <li>
          <a
            :href="uccp_dashboard_url"
            @click="syncSessionCookiesForUccp"
          >
            <i class="fa fa-tachometer-alt" style="color: #424242;"></i>
            UCCP Dashboard
          </a>
        </li>
      </ul>
    </div>
    <b-nav v-if="!hideDepartment" class="ml-auto" style="float:right;">
      <b-nav-item-dropdown right class="lgout_main" style="bottom: 10px;
    font-size: 15px;">
        <template slot="button-content">
          <img
            src="static/img/avatars/default-img.png"
            class="img-avatar"
            alt="admin@bootstrapmaster.com"
            style="display:none;"
          />
          <span class="d-md-down-none">{{username}}</span>
        </template>
      <!-- <b-dropdown-item @click="umsChangePwd" class="lgout">
          <i class="fa fa-lock"></i>  Change Password
        </b-dropdown-item> -->
        <b-dropdown-item @click="logout" class="lgout">
          <i class="fa fa-lock"></i> Logout
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-nav>
    <br />

    <div
      v-if="!hideDepartment &&  this.DepartmentName != ''"
      style="position: absolute;right: 11px;top: 28px;font-size: 14px;"
    >
      {{DepartmentName}}
      <i
        title="Change department"
        class="fa fa-pencil"
        style="color:#87ceeb;cursor: pointer; "
        @click="subDepartmentModalOpen()"
      ></i>
    </div>

    <div
      v-if="!hideDepartment &&  this.DepartmentName == ''"
      style="position: absolute;right: 11px;top: 28px;font-size: 14px;     color: red;"
    >Department not available</div>
    <b-modal
      v-model="subDepartmentModal"
      @close="subDepartmentModal = false"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <div class="col-lg-12">
        <b-card style="background-color: transparent; border: 0px solid transparent;">
          <div style="margin-bottom: 10px;">
            <h5 class="modal-title" style="display: inline;">Department</h5>
            <button
              type="button"
              aria-label="Close"
              @click="subDepartmentModalClose()"
              class="close"
              style="color: red;"
              title="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-12">
                <label class="col-md-5">Department Name:</label>

                <select
                  v-model="sebDepartment"
                  class="select col-md-6"
                  style="cursor: pointer; height: 38px; background-color: rgb(255, 251, 251); border-color: #7ca2e8; text-align-last:center; "
                >
                  <option disabled value>---Select department---</option>
                  <option
                    v-for="option in DepartmentOptionObj"
                    v-bind:value="option"
                    v-bind:key="option.value"
                  >{{ option.text }}</option>
                </select>
              </div>
              <div class="form-group col-md-12" style="    text-align: center;">
                <input
                  class="btn btn-primary"
                  style="    cursor: pointer;"
                  type="button"
                  value="Change Department"
                  @click="changeDepartment()"
                />
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </b-modal>
  </header>
</template>
<script>
import apiUrl from "../constants";
import CryptoJS from "crypto-js";
import axios from "axios";
import { BasicSelect } from "vue-search-select";
import constantVariable from "../constantVariable";
import commonFunction from '../commonFunction';
import keycloak from "../Keycloak"

export default {
  name: "header",
  components: {
    BasicSelect
  },
  data() {
    return {
      userId: "",
      username: "",
      usertype: "",
      logindata: [],
      navItem: [],
      permissions: [],
      DepartmentID: "",
      DepartmentName: "",
      activeIndex: "",
      subDepartmentModal: false,
      DepartmentOptionObj: [],
      sebDepartment: {},
      ums_url:apiUrl.ums_url,
      analytics_dashboard_url: apiUrl.analytics_dashboard_url,
      uccp_dashboard_url: apiUrl.uccp_dashboard_url,
      userRole: "",
      isLoggingOut: false,
      fullPage: true,
    };
  },
  computed: {
  hideDepartment() {
    // Hide department info if URL path includes 'adi' (case-insensitive)
    return this.$route.path.toLowerCase().includes("adi");
  },
  showUccpDashboard() {
    // UCCP Dashboard tab is restricted to Team Leader and Associate roles only
    const allowedRoles = ["team leader", "teamleader", "associate"];
    return allowedRoles.includes((this.userRole || "").toLowerCase().trim());
  }
},

  async mounted() {
    this.activeIndex = this.$route.path;

    var userdetailEncrypt = window.localStorage.getItem("userdetail");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.uasertype = userdetail[0].utype;
    this.username = userdetail[0].FirstName;
    this.DepartmentID = userdetail[0].DepartmentID;
    this.userId = userdetail[0].userid;
    try {
      this.userRole =
        (userdetail[0].roles && userdetail[0].roles[0] && userdetail[0].roles[0].rolename) || "";
    } catch (e) {
      this.userRole = "";
    }

    var permissionEncrypt = window.localStorage.getItem("permissiondata");
    var bytes1 = CryptoJS.AES.decrypt(permissionEncrypt.toString(), "Key");
    var plaintext1 = bytes1.toString(CryptoJS.enc.Utf8);

    this.navItem = JSON.parse(plaintext1);
    this.navItem.sort(function(a, b) {
      return a.sequence - b.sequence;
    });



  //  console.log("this.navItem header "+JSON.stringify(this.navItem));

    //await this.getDepartmentNameFromId();
    //await this.getUserSubDepartmentList();

    var userSubDepartmentId = window.localStorage.getItem(
      "userSubDepartmentId"
    );

    var userSubDepartment = JSON.parse(
      window.localStorage.getItem("userSubDepartment")
    );

    if (userSubDepartment) {
      for (var i = 0; i < userSubDepartment.length; i++) {
        var obj = {
          value: userSubDepartment[i].value,
          text: userSubDepartment[i].text
        };

        this.DepartmentOptionObj.push(obj);
      }
    }

    if (userSubDepartmentId != "") {
      this.sebDepartment = JSON.parse(userSubDepartmentId);
      this.DepartmentName = this.sebDepartment.text;
    }
  },
  methods: {
    changeDepartment(data) {
      window.localStorage.setItem(
        "userSubDepartmentId",
        JSON.stringify(this.sebDepartment)
      );
      this.$router.go();
    },

    subDepartmentModalOpen() {
      this.subDepartmentModal = true;
    },

    subDepartmentModalClose() {
      this.subDepartmentModal = false;
    },

    sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-hidden");
    },

    async getDepartmentNameFromId() {
      //this.OrderDetails.srUserData.FirstName = '';
      let token = constantVariable.DEPARTMENT_ID_TOKEN;
      this.input = {
        DepartmentID: this.DepartmentID
      };
      await axios({
        method: "POST",
        url: apiUrl.api_url + "getDepartmentNameFromId",
        headers: commonFunction.getusertoken(),
        data: this.input,
      }).then(
        result => {
          if (result.data.data.data.code === 200) {
            this.DepartmentName = result.data.data.data.data.DepartmentName;
          } else {
            let msg = result.data.data.data.error;
            this.$alertify.error(msg);
          }
        },
        error => {
          let msg = error;
          this.$alertify.error(msg);
        }
      );
    },

    async getUserSubDepartmentList() {
      this.input = {
        UserId: this.userId
      };
      await axios({
        method: "POST",
        url: apiUrl.api_url + "getUserSubDepartmentList",
        headers: commonFunction.getusertoken(),
        data: this.input
      }).then(
        result => {
          if (result.data.data.data.code === 200) {
            var subDepartment = result.data.data.data.data[0].SubdepartmentID;
            if (subDepartment) {
              for (var i = 0; i < subDepartment.length; i++) {
                var obj = {
                  value: subDepartment[i].SubdepartmentID,
                  text: subDepartment[i].Subdepartment
                };
                this.DepartmentOptionObj.push(obj);
                this.sebDepartment = subDepartment[i].SubdepartmentID;
                this.DepartmentName = subDepartment[i].Subdepartment;
              }
            }
          } else {
            let msg = result.data.data.data.error;
            this.$alertify.error(msg);
          }
        },
        error => {
          let msg = error;
          this.$alertify.error(msg);
        }
      );
    },

    navigateTo(prm) {
      this.$router.push(prm);
    },

    // Keys we mirror from localStorage into `.xbees.in`-scoped cookies so that
    // sibling apps (e.g. UCCP Dashboard) hosted on a different xbees.in
    // subdomain can pick up the same session data without an extra login round-trip.
    getSharedSessionKeys() {
      return [
        "userToken",
        "isLoggedIn",
        "permissiondata",
        "userdetail",
        "userReporting",
        "userSubDepartment",
        "userhubList",
        "userclientList",
        "userclientNames",
        "userSubDepartmentId",
        "lastLoginDate"
      ];
    },

    // Derive the cross-subdomain cookie Domain from the current hostname
    // (e.g. `stagecltcrm.xbees.in` -> `.xbees.in`). Returns "" for
    // localhost / raw IPs / single-label hosts where cross-subdomain sharing
    // isn't meaningful, in which case the cookie stays scoped to the current host.
    getSharedCookieDomain() {
      var host = window.location.hostname || "";
      if (!host || host === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
        return "";
      }
      var parts = host.split(".");
      if (parts.length < 2) return "";
      return "." + parts.slice(-2).join(".");
    },

    writeSharedCookie(name, value) {
      if (value === null || value === undefined) return;
      var domain = this.getSharedCookieDomain();
      var attrs = ["Path=/", "SameSite=Lax"];
      if (window.location.protocol === "https:") attrs.push("Secure");
      if (domain) attrs.push("Domain=" + domain);
      // Session cookie (no Expires) so it disappears with the browser session,
      // matching how localStorage is treated in this app.
      document.cookie = name + "=" + encodeURIComponent(value) + "; " + attrs.join("; ");
    },

    clearSharedCookie(name) {
      var domain = this.getSharedCookieDomain();
      var attrs = [
        "Path=/",
        "Expires=Thu, 01 Jan 1970 00:00:00 GMT",
        "SameSite=Lax"
      ];
      if (window.location.protocol === "https:") attrs.push("Secure");
      if (domain) attrs.push("Domain=" + domain);
      document.cookie = name + "=; " + attrs.join("; ");
    },

    syncSessionCookiesForUccp() {
      // Mirror the current CRM session into parent-domain cookies so the UCCP
      // dashboard (same Keycloak realm, sibling subdomain) can read them.
      // Same-tab navigation: browser continues to uccp_dashboard_url after this
      // synchronous handler returns, with the fresh cookies attached.
      try {
        var keys = this.getSharedSessionKeys();
        for (var i = 0; i < keys.length; i++) {
          var val = window.localStorage.getItem(keys[i]);
          if (val !== null) this.writeSharedCookie(keys[i], val);
        }
      } catch (err) {
        console.warn("Failed to sync session cookies for UCCP dashboard", err);
      }
    },

    clearSharedSessionCookies() {
      try {
        var keys = this.getSharedSessionKeys();
        for (var i = 0; i < keys.length; i++) this.clearSharedCookie(keys[i]);
      } catch (err) {
        console.warn("Failed to clear shared session cookies", err);
      }
    },

    logout(e) {
      if (this.isLoggingOut) return;
      this.isLoggingOut = true;
      
      console.log("Starting logout process");
      
      // Clear localStorage immediately
      localStorage.removeItem("permissiondata");
      localStorage.removeItem("userdetail");
      localStorage.removeItem("userToken");
      localStorage.removeItem("isLoggedIn");

      // Also clear parent-domain cookies we may have written for the UCCP
      // dashboard so its session data doesn't outlive the CRM login.
      this.clearSharedSessionCookies();
      
      // Try to call API but don't wait for it
      try {
        const tokenHeaders = commonFunction.getusertoken();
        if (tokenHeaders && tokenHeaders.Authorization) {
          axios({
            method: "POST",
            url: apiUrl.api_url + "rateLimitDelKeyonLogOut",
            headers: tokenHeaders,
            data: {},
            timeout: 3000
          }).catch(error => {
            console.log("Logout API error (non-blocking):", error);
          });
        }
      } catch (error) {
        console.log("Error calling logout API:", error);
      }
      
      // Logout immediately without delay
      try {
        if (keycloak && typeof keycloak.logout === 'function') {
          keycloak.logout();
        } else {
          console.warn("Keycloak not available, redirecting to login");
          this.$router.push('/login');
          window.location.reload();
        }
      } catch (error) {
        console.error("Error during keycloak logout:", error);
        this.$router.push('/login');
        window.location.reload();
      } finally {
        this.isLoggingOut = false;
      }
    },

umsChangePwd(){
window.open(this.ums_url+'#/forgotpassword',"_blank")

},
    changepassword() {
      this.$router.push("/changepassword");
    },

    editProfile() {
      if (this.usertype == "Merchant") this.$router.push("/merchantProfile");
      else if (this.usertype == "Client") this.$router.push("/companyProfile");
      else this.$router.push("/");
    },

    sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-minimized");
    },

    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-mobile-show");
    },

    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("aside-menu-hidden");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Header.vue?2ee38821